import { createContext, PropsWithChildren, useContext } from 'react';

export const NameSpaceContext = createContext<string | null>(null);

interface NameSpaceProviderProps extends PropsWithChildren {
  namespace: string;
}

export function NameSpaceProvider({ children, namespace }: NameSpaceProviderProps) {
  const oldNamespace = useContext(NameSpaceContext);
  const newNamespace = oldNamespace ? oldNamespace.concat(`.${namespace}`) : namespace;

  return <NameSpaceContext.Provider value={newNamespace}>{children}</NameSpaceContext.Provider>;
}
